<script>
import { fade } from 'svelte/transition';
export let shown = false;
</script>

<div transition:fade="{{duration: 500 }}" class="overlay {(shown) ? "shown" : ""}">
    <div class="overlaycontent">
        <slot></slot>
    </div>
</div>

<style>
.overlay {
    position: fixed; /* Sit on top of the page content */
    display: none; /* Hidden by default */
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5); /* Black background with opacity */
    z-index: 99999;
    cursor: pointer; /* Add a pointer on hover */
}
.shown {
    display: flex;
    justify-content: center;
    align-items: center;
}
.overlaycontent {
    width: 50%;
    min-width: 200px;
    max-width: 600px;
}
</style>